<div class="m-auto">
    <div class="ps-2 pt-2">
        <!-- {{jsonData.documents|json}}
        {{artifact.documents|json}}
        {{documents|json}} -->
        <app-file-upload  
            [appConfig]="fileUploadConfig" 
            [btnName]="'Upload Supporting Document'" 
            [artifact]="artifact" 
            [type]="ARTIFACT_KEY.UPLOADEXISTING"
            [uploadSummary]="jsonData.documents"
            [artifactUpload]="true"
            [artifact]="artifact"
            [locked]="artifact.locked"
            [docTypes]="artifact.docTypes"
            (emitData)="onDocumentUpdate()"
            (uploadFailure)="onUploadFailure($event)" >
        </app-file-upload>
    </div>
</div>